const styles = theme => {
  const font = theme.typography.overline || {};
  return {
    root: {
      width: '100%',
      padding: '0',
      // TODO: move this to a constant
      boxShadow: `1px 2px 4px rgba(0, 0, 0, 0.18)`,
      backgroundColor: theme.palette.common.white
    },
    sticky: ({ stepperZIndex }) => ({
      position: 'fixed',
      left: '0',
      right: '0',
      zIndex: stepperZIndex
    }),
    stepperWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    tabs: {
      width: '100%',
      padding: `0 ${theme.spacing(2)}px`,
      height: '64px',
      '& div.MuiTabs-scroller': {
        '& .MuiTabs-flexContainer': {
          height: '100%'
        }
      }
    },
    tab: ({ disableRipple }) => ({
      borderBottom: `2px solid ${theme.palette.grey[600]}`,
      padding: `0 ${theme.spacing(1)}px`,
      marginLeft: theme.spacing(2),
      cursor: disableRipple ? 'default' : 'cursor',
      '& span.MuiTab-wrapper': {
        alignItems: 'flex-start'
      },
      '&.Mui-selected': {
        fontWeight: 'bold'
      },
      ...font
    }),
    completedTab: ({
      completedStepTextColor,
      completedStepIndicatorColor
    }) => ({
      // disabled this for now, based on discussion with Design team
      // color: theme.palette[completedStepTextColor].main,
      // borderBottomColor: theme.palette[completedStepIndicatorColor].main
    }),
    tabContent: {
      display: 'flex',
      alignItems: 'center'
    }
  };
};

export default styles;
